import { render, staticRenderFns } from "./RecTable.vue?vue&type=template&id=1cc519c8&"
import script from "./RecTable.vue?vue&type=script&lang=js&"
export * from "./RecTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports